import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import './wallboard-page.css';

import { DashboardWallboard } from "./dashboard/wallboard-dashboard";
import { TableWallboard } from "./table/wallboard-table";
import { StatusOverviewWallboard } from "./status-overview/wallboard-statusoverview";
import { loadWallboard } from "./wallboards";
import { WALLBOARDS_URL } from '../../config';
import { PageHeaderButtons, PageFooterContent } from '../menu';

import { 
    PageFooter, 
    PageHeader, 
    PageLayout, 
    PageMenu, 
    Header, 
    LoadingIndicator, 
    Switch,
    Button,
    Error,
    PageSection,
    DropDown,
} from '../../components/components';

export function WallboardPage() {
    const navigate = useNavigate();
    const { wallboardId } = useParams();

    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [wallboard, setWallboard] = useState();
    const [fullscreen, setFullscreen] = useState(false);
    const [refresh, setRefresh] = useState(5);

    useEffect(() => {
        async function load() {
            setLoading(true);
            setError("");
            setWallboard(null);
    
            const [loaded, wallboard, error] = await loadWallboard(wallboardId);
            if (!loaded) {
                setLoading(false);
                setError(error);
                return;
            }
    
            setLoading(false);
            setWallboard(wallboard);
        }
        load();
    }, [wallboardId, reload]);

    function tryReload() {
        setReload(!reload);
    }

    const renderWallboard = () => {
        return (
            <>
            <Header class="wallboard-header">
                <span>{wallboard.name}</span>
                <DropDown
                    class="no-margins"
                    value={`${refresh} seconds refresh`}>
                    <Button 
                        variant="label" 
                        icon={refresh === 5 ? "ic_check" : ""}
                        clicked={() => setRefresh(5)}>
                        5 seconds
                    </Button>
                    <Button 
                        variant="label" 
                        icon={refresh === 10 ? "ic_check" : ""}
                        clicked={() => setRefresh(10)}>
                        10 seconds
                    </Button>
                    <Button 
                        variant="label" 
                        icon={refresh === 15 ? "ic_check" : ""}
                        clicked={() => setRefresh(15)}>
                        15 seconds
                    </Button>
                    <Button 
                        variant="label" 
                        icon={refresh === 30 ? "ic_check" : ""}
                        clicked={() => setRefresh(30)}>
                        30 seconds
                    </Button>
                    <Button 
                        variant="label" 
                        icon={refresh === 60 ? "ic_check" : ""}
                        clicked={() => setRefresh(60)}>
                        60 seconds
                    </Button>
                </DropDown>
                <Switch value={fullscreen} valueChanged={value => setFullscreen(value)} reverse="true">
                    Fullscreen
                </Switch>
            </Header>
            
            {wallboard.type === "dashboard" &&
                <DashboardWallboard wallboard={wallboard} refresh={refresh} />
            }

            {wallboard.type === "table" &&
                <TableWallboard wallboard={wallboard} refresh={refresh} />
            }

            {wallboard.type === "status-overview" &&
                <StatusOverviewWallboard wallboard={wallboard} refresh={refresh} />
            }
            </>
        );
    };

    if (fullscreen) {
        return (
            <PageLayout class="fullscreen">
                {renderWallboard()}
            </PageLayout>
        );
    }

    return (
        <PageLayout
            header={<PageHeader name="Puzzel wallboards" menu={<PageMenu><PageHeaderButtons /></PageMenu>} />}
            footer={<PageFooter><PageFooterContent /></PageFooter>}>
            <PageSection>
                <Button variant="label" icon="ic_keyboard_backward" clicked={() => navigate(WALLBOARDS_URL)}>
                    Wallboards
                </Button>

                { error &&
                    <Error text={error}>
                        <Button variant="secondary" clicked={() => tryReload()} icon="ic_refresh">
                            Retry
                        </Button>
                    </Error>
                }
                {loading &&
                    <LoadingIndicator margins="large" />
                }

                {wallboard &&
                    renderWallboard()
                }
            </PageSection>
        </PageLayout>
    );
}